<style scoped lang="scss">

</style>

<template>
    <div>
        <div v-if="application">

            <fieldset data-uk-margin class="agreement-container">
                <legend class="agreement-title">Third Party Authorization</legend>

                <div class="uk-grid">
                    <div class="uk-width-1-1">
                        <div class="uk-block uk-block-default">
                            <p align="justify">I authorize KHRC, my landlord or its authorized agent, providers of utilities and telecommunications services including internet, and any entity that provides assistance or housing stability services (including but not limited to: federal, state, tribal, municipality, charitable organization and nonprofits) to share and verify information provided by me or others in support of my KERA application, including but not limited to personally identifiable information, and benefits awarded or denied to me, previously and prospectively.</p>
                            <p align="justify">If applicable, I authorize the City of Wichita to provide KHRC with confidential benefit data including but not limited to first and last name, address, phone number, e-mail address, {{ ssnLabel.toLowerCase() }} of the head of household and amount due, paid, fees and assistance awarded for each month and year for each of the following programs: Wichita Emergency Rental Assistance Program, Emergency Assistance Program, Section 8 Housing Choice Voucher Program or ESG funded Homeless Prevention Programs.</p>

                        </div>
                    </div>
                </div>

            </fieldset>

            <div class="uk-width-1-1 uk-grid uk-margin-large-bottom" v-if="application.household">
                <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                    <div v-if="member.age >= 18">
                        <div class="uk-width-medium-1-1">

                            <legend>{{ member.first_name }} {{ member.last_name }}</legend>

                            <validated-section :errors="errors" :field="'signature_'+member.id">
                                <signature-box @updated="onSignatureUpdated"
                                               :user-key="member.id"
                                               :is-signed="signatureData[member.id] && signatureData[member.id].third_party_authorization_signed_at"
                                               :completed="signatureData[member.id] && signatureData[member.id].completed"
                                               :name="member.first_name + ' ' + member.last_name"
                                               :color="programSettings['primary-program-color']"
                                               ref="signatureBox"
                                ></signature-box>
                            </validated-section>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";

    export default {
        name: "Step7",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                signatureData: {},
                errors: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
                signatures: state => state.signatures,
            }),
            ...mapGetters('Application', [ 'programSettings' ]),
            ssnLabel() {
                if (this.programSettings['use-itin'])
                {
                    return `SSN or ITIN`
                } else {
                    return `Social Security Number`
                }
            },
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            initData() {
                _.each(this.application.household.members, member => {
                    if(member.age >= 18) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-privacy-policy`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, { third_party_authorization_signed_at: signatureFiltered.created_at, completed: true });
                        }
                    }
                })
            },
            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData[$event.key], 'third_party_authorization_signed_at', $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            async validateStep() {
                this.errors = {};
                // Local Validation
                for(var i in this.application.household.members) {
                    let member = this.application.household.members[i];
                    if(member.age >= 18) {
                        if(!this.signatureData[member.id]) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[member.id] && this.signatureData[member.id].third_party_authorization_signed_at == null) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            async save() {
                let data = {
                    signatures: this.signatureData,
                }
                let r = axios.put(`/api/hope/applications/${this.application.id}/step-7`, data);
                await this.$store.dispatch('Application/fetch', this.application.id);
                return r;
            }
        }
    }
</script>
